module.exports = __webpack_public_path__ + "img/f.b68f6a53.png";